import { useNotificationStore } from '@wwt/core/notifications'

import { Badge } from '@/shared/ui/Badge.tsx'

export const NotificationBadge = () => {
	const notificationsQuantity = useNotificationStore(
		state => state.notifications.NEW.length
	)

	if (notificationsQuantity <= 0) {
		return null
	}

	return (
		<Badge className="absolute top-0 -right-[0.2rem]">
			{notificationsQuantity}
		</Badge>
	)
}
